/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArenaScoringEvent } from './ArenaScoringEvent';
import {
    ArenaScoringEventFromJSON,
    ArenaScoringEventFromJSONTyped,
    ArenaScoringEventToJSON,
    ArenaScoringEventToJSONTyped,
} from './ArenaScoringEvent';
import type { MetricType } from './MetricType';
import {
    MetricTypeFromJSON,
    MetricTypeFromJSONTyped,
    MetricTypeToJSON,
    MetricTypeToJSONTyped,
} from './MetricType';
import type { ArenaScoringEventTargetRange } from './ArenaScoringEventTargetRange';
import {
    ArenaScoringEventTargetRangeFromJSON,
    ArenaScoringEventTargetRangeFromJSONTyped,
    ArenaScoringEventTargetRangeToJSON,
    ArenaScoringEventTargetRangeToJSONTyped,
} from './ArenaScoringEventTargetRange';

/**
 * Configuration for Race (METRIC_THRESHOLD) strategy
 * @export
 * @interface RaceConfig
 */
export interface RaceConfig {
    /**
     * Events that can be used for race mode with default targets
     * @type {Array<ArenaScoringEvent>}
     * @memberof RaceConfig
     */
    scoringEvents?: Array<ArenaScoringEvent>;
    /**
     * Default event to use when creating a challenge
     * @type {string}
     * @memberof RaceConfig
     */
    defaultEventTypeId?: string;
    /**
     * (Deprecated) Which metrics can be raced
     * @type {Array<MetricType>}
     * @memberof RaceConfig
     */
    allowedMetrics?: Array<MetricType>;
    /**
     * 
     * @type {MetricType}
     * @memberof RaceConfig
     */
    defaultMetric?: MetricType;
    /**
     * (Deprecated) Per-metric target ranges
     * @type {{ [key: string]: ArenaScoringEventTargetRange; }}
     * @memberof RaceConfig
     */
    metricRanges?: { [key: string]: ArenaScoringEventTargetRange; };
}



/**
 * Check if a given object implements the RaceConfig interface.
 */
export function instanceOfRaceConfig(value: object): value is RaceConfig {
    return true;
}

export function RaceConfigFromJSON(json: any): RaceConfig {
    return RaceConfigFromJSONTyped(json, false);
}

export function RaceConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaceConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'scoringEvents': json['scoringEvents'] == null ? undefined : ((json['scoringEvents'] as Array<any>).map(ArenaScoringEventFromJSON)),
        'defaultEventTypeId': json['defaultEventTypeId'] == null ? undefined : json['defaultEventTypeId'],
        'allowedMetrics': json['allowedMetrics'] == null ? undefined : ((json['allowedMetrics'] as Array<any>).map(MetricTypeFromJSON)),
        'defaultMetric': json['defaultMetric'] == null ? undefined : MetricTypeFromJSON(json['defaultMetric']),
        'metricRanges': json['metricRanges'] == null ? undefined : (mapValues(json['metricRanges'], ArenaScoringEventTargetRangeFromJSON)),
    };
}

export function RaceConfigToJSON(json: any): RaceConfig {
    return RaceConfigToJSONTyped(json, false);
}

export function RaceConfigToJSONTyped(value?: RaceConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scoringEvents': value['scoringEvents'] == null ? undefined : ((value['scoringEvents'] as Array<any>).map(ArenaScoringEventToJSON)),
        'defaultEventTypeId': value['defaultEventTypeId'],
        'allowedMetrics': value['allowedMetrics'] == null ? undefined : ((value['allowedMetrics'] as Array<any>).map(MetricTypeToJSON)),
        'defaultMetric': MetricTypeToJSON(value['defaultMetric']),
        'metricRanges': value['metricRanges'] == null ? undefined : (mapValues(value['metricRanges'], ArenaScoringEventTargetRangeToJSON)),
    };
}

